module.exports = __webpack_public_path__ + "static/media/Town5.ab6b0856.png";